import { STATUS_TYPE } from '../../../enum';

export interface GetSettings {
  id: string;
}

export interface FindSettings {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface Settings {
  id: string;
  name: string;
  value: string;
  valueType: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: Settings[];
  dealerSetupFee: number | undefined;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  dealerSetupFee: undefined,
  skip: 0,
  limit: 15,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
